import React from "react"
import { Navigate } from "react-router-dom"

import Dashboard from "../pages/Dashboard/index"
import OwnerDashboard from "../pages/Dashboard/OwnerDashboard"
import Login from "../pages/Authentication/Login"
import { inventoryRoutes } from "./route/inventory"
import { settingsRoutes } from "./route/settings"
import { procurementRoutes } from "./route/procurement"
import { hrmsRoutes } from "./route/hrms"
import { estimationRoutes } from "./route/estimation"
import { projectManagementRoutes } from "./route/projectManagement"
import Logout from "../pages/Authentication/Logout"
import ModulesIndex from "../pages/modules"
import RolesIndex from "../pages/Roles"
import EditRole from "../pages/Roles/edit"
import { centalStoreRoutes } from "./route/centralStore"
import { financeRoutes } from "./route/finance"
import UserProfile from "../pages/Profile/userProfile/index"
import { hrSelfServiceRoutes } from "./route/hrSelfService"
import { userManagementRoutes } from "./route/userManagement"
import { campManagementRoutes } from "./route/campManagement"
import { fleetRoutes } from "./route/fleet"
import ThemeOptions from "../pages/Themes/themeOption"
import NotFound from "../pages/ErrorPage/notFound"
import NetworkError from "../pages/ErrorPage/networkError"
import NotificationList from "../pages/Notification/listNotification"
import ExpiredNotificationList from "../pages/Notification/listExpiredNotification"
import Dashboardesign from "../pages/Dashboard/dashboardesign"
import { PrivateSettings } from "./route/truncate"
import Tenancy from "../pages/Tenancy"
import CompanyEdit from "../pages/Tenancy/CompanyEdit"
import AdminTrades from "../pages/Admin/Trades"
import AdminAttendanceCodes from "../pages/Admin/AttendanceCodes"
import AdminApplication from "../pages/Admin/Application"
import AdminSponsors from "../pages/Admin/Sponsors"
import AdminSponsorForm from "../pages/Admin/SponsorForm"
import AdminDocumentTypes from "../pages/Admin/DocumentTypes"
import DeveloperHub from "../pages/Developer/Hub"
import DeveloperModules from "../pages/Developer/Modules"
import DeveloperFieldManager from "../pages/Developer/FieldManager"
import DeveloperApplicationSettings from "../pages/Developer/ApplicationSettings"
import DeveloperLedgerFeatures from "../pages/Developer/LedgerFeatures"
import DeveloperFleetAccounts from "../pages/Developer/FleetAccounts"
import Prefix from "../pages/Settings/Prefix"

const userRoutes = [
  { path: "/dashboard", component: <OwnerDashboard /> },
  { path: "/dashboard-legacy", component: <Dashboard /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {path: "/dashboardesign", component: <Dashboardesign />},
  { path: "/logout", component: <Logout /> },
  { path: "/profile", component: <UserProfile /> },
  { path: "/theme-options", component: <ThemeOptions /> },
  { path: "/modules", component: <ModulesIndex /> },
  { path: "/roles", component: <RolesIndex /> },
  { path: "/settings-roles/edit/:id", component: <EditRole /> },
  { path: "/settings-roles/add", component: <EditRole /> },
  { path: "/network-error", component: <NetworkError /> },
  { path: "/notification", component: <NotificationList /> },
  { path: "/notification/document-expiry", component: <ExpiredNotificationList /> },
  { path: "/company-management", component: <Tenancy /> },
  { path: "/company-management/companies/new", component: <CompanyEdit /> },
  { path: "/company-management/companies/:id", component: <CompanyEdit /> },
  { path: "/admin/application", component: <AdminApplication /> },
  { path: "/admin/sponsors", component: <AdminSponsors /> },
  { path: "/admin/sponsors/create", component: <AdminSponsorForm /> },
  { path: "/admin/sponsors/:id/edit", component: <AdminSponsorForm /> },
  { path: "/admin/trades", component: <AdminTrades /> },
  { path: "/admin/attendance-codes", component: <AdminAttendanceCodes /> },
  { path: "/admin/document-types", component: <AdminDocumentTypes /> },
  // Developer hub (hidden, vendor-only — server gated by `developer` middleware)
  { path: "/developer", component: <DeveloperHub /> },
  { path: "/developer/modules", component: <DeveloperModules /> },
  { path: "/developer/field-manager", component: <DeveloperFieldManager /> },
  { path: "/developer/application-settings", component: <DeveloperApplicationSettings /> },
  { path: "/developer/ledger-features", component: <DeveloperLedgerFeatures /> },
  { path: "/developer/fleet-accounts", component: <DeveloperFleetAccounts /> },
  { path: "/developer/documents-manager", component: <AdminDocumentTypes /> },
  { path: "/developer/prefixes", component: <Prefix /> },
  { path: "*", component: <NotFound /> },
  ...inventoryRoutes,
  ...settingsRoutes,
  ...hrmsRoutes,
  ...procurementRoutes,
  ...estimationRoutes,
  ...projectManagementRoutes,
  ...centalStoreRoutes,
  ...financeRoutes,
  ...hrSelfServiceRoutes,
  ...userManagementRoutes,
  ...campManagementRoutes,
  ...fleetRoutes,
  ...PrivateSettings,
]

const authRoutes = [{ path: "/login", component: <Login /> }]

export { userRoutes, authRoutes }
